import { TaskCategories } from 'enums/taskCategories';

import { SlidingPaneMode } from './slidingInPane.types';

export const SLIDING_PANE_SIZE_PERCENT = 0.485;
export const SLIDING_PANE_MAX_WIDTH_PX = 760;
export const SLIDING_PANE_NARROWER_WIDTH_PX = 500;

const multiColumnTaskList = [TaskCategories.Renewal, TaskCategories.Async, TaskCategories.Replacement];

const aiMessagePanelTaskList = [TaskCategories.Messages, TaskCategories.FrontDesk];

export const getSlidingPaneMode = (category?: TaskCategories): SlidingPaneMode => {
  if (!category) return SlidingPaneMode.ORDINARY;
  if (aiMessagePanelTaskList.includes(category)) return SlidingPaneMode.AI_MESSAGE_PANEL;
  if (multiColumnTaskList.includes(category)) return SlidingPaneMode.MULTI_COLUMN;
  return SlidingPaneMode.ORDINARY;
};
